const birthDateMask = (value) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d{2})(\d{4})/, '$1/$2/$3')
    .replace(/(.{10})\d+?$/, '$1'); // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
};

export default birthDateMask;
